import React from 'react'
import { withRouter } from 'react-router'
import enhanceLogin from 'react-social-login'
import {
  FacebookLoginButton,
  GoogleLoginButton,
} from 'react-social-login-buttons'
import { postSignUpFacebook, postSignUpGoogle } from '../../api/sync/index'

const SocialButton = ({ children, triggerLogin, ...props }) => (
  <div onClick={triggerLogin} {...props}>
    {children}
  </div>
)

const SocialLoginButton = enhanceLogin(SocialButton)

class SocialLogin extends React.Component {
  state = {
    rerender: false,
    renderGoogle: false,
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ renderGoogle: true })
    }, 1000)
  }

  handleGoogleLogin = (user) => {
    const accessToken = user._token.accessToken
    postSignUpGoogle(accessToken).then(() => this.props.setLogin())
    this.props.onClose()
  }

  handleFacebookLogin = (user) => {
    const accessToken = user._token.accessToken
    postSignUpFacebook(accessToken).then(() => this.props.setLogin())
    this.props.onClose()
  }

  handleSocialLoginFailure = (err) => {
    this.setState({ rerender: true }, () => {
      this.setState({ rerender: false })
    })
  }

  render() {
    const { rerender, renderGoogle } = this.state
    return !rerender ? (
      <div>
        <SocialLoginButton
          style={{ display: 'inline-block', width: '100%' }}
          provider="facebook"
          appId="783522201998315"
          scope="email"
          onLoginSuccess={this.handleFacebookLogin}
          onLoginFailure={this.handleSocialLoginFailure}
        >
          <FacebookLoginButton />
        </SocialLoginButton>
        <SocialLoginButton
          style={{ display: 'inline-block', width: '100%' }}
          provider="google"
          appId="494001152907-prmjuql6q6objgmqv0met1k7ep3nma94.apps.googleusercontent.com"
          onLoginSuccess={this.handleGoogleLogin}
          onLoginFailure={this.handleSocialLoginFailure}
          loading={!renderGoogle}
        >
          <GoogleLoginButton />
        </SocialLoginButton>
      </div>
    ) : null
  }
}

export default withRouter(SocialLogin)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/SocialButton/index.js